import React, { useState, useEffect } from "react";
import Nav from "../components/Nav";
import { sendBvn, validateNIN, sendNIN, validateBVN } from "../Utils/apis";
import "../assets/css/style.css";
import swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import success from "../assets/Img/success.json";
import Lottie from "lottie-react";
import { BeatLoader } from "react-spinners";
import { LuBadgeHelp } from "react-icons/lu";
import axios from 'axios';

const Home = () => {
  const [bvn, setBvn] = useState("");
  const [otp, setOtp] = useState("");
  const [nin, setNin] = useState("");
  const [bvnFirstName, setBvnFirstName] = useState("");
  const [bvnLastName, setBvnLastName] = useState("");
  const [bvnDateOfBirth, setBvnDateOfBirth] = useState("");
  const [enteredOtp, setEnteredOtp] = useState("");
  const [showBvn, setShowBvn] = useState(true);
  const [showOTPForm, setShowOTPForm] = useState(false);
  const [showNINForm, setShowNINForm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [IPFrontEnd, setIp] = useState(''); 

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchIp = async () => {
      try {
        const response = await axios.get('https://api.ipify.org?format=json');
        const IPFrontEnd = response.data.ip;
        setIp(IPFrontEnd);
        // console.log('Fetched IP Address:', IPFrontEnd);
      } catch (error) {
        console.error('Error fetching the IP address', error);
      }
    };

    fetchIp();
  }, []);

  const handleSubmitBvn = async (e) => {
    e.preventDefault();

    if (bvn.length !== 11) {
      toast.error("Invalid BVN");
      return;
    }

    try {
      setLoading(true);
      const res = await sendBvn(bvn);
      // console.log("SSSS",res);
      if (res?.code === "00") {
        // console.log("response", res?.Data);
        const data = res.Data;
        const otp = data?.Otp;
        // console.log("OTP", otp)
        setOtp(otp);
        const { firstName, lastName, dateOfBirth } = await validateBVN(bvn);
        // console.log("DEETS",firstName, lastName, dateOfBirth);
        setBvnFirstName(firstName.toLowerCase().trim());
        setBvnLastName(lastName.toLowerCase().trim());
        setBvnDateOfBirth(dateOfBirth);
        toast.success("BVN Validation Successful");
        setLoading(false);
        setShowBvn(false);
        setShowOTPForm(true);
      } else {
        setLoading(false);
        // console.log("error res:", res);
        // console.log("error res message:", res.data.message);
        return swal.fire("Error", "BVN Not linked to any account", "error");
      }
    } catch (error) {
      setLoading(false);
      console.log("ERROR", error);
      return swal.fire("Error", "Something Went Wrong", "error");
    }
  };

  const handleOtpValidation = (e) => {
    e.preventDefault();
    if (enteredOtp.length !== 6) {
      setLoading(false);
      return swal.fire("Error", "Invalid OTP Entered", "error");
    }

    setLoading(true);
    if (otp === enteredOtp) {
      setLoading(false);
      setShowOTPForm(false);
      setShowNINForm(true);
      toast.success("OTP Validation Successful");
    } else {
      setLoading(false);
      return swal.fire("Error", "Invalid OTP Entered", "error");
    }
  };

  const handleNINSubmission = async (e) => {
    e.preventDefault();

    if (nin.length !== 11) {
      toast.error("Invalid NIN");

      return;
    } else {
      try {
        setLoading(true);
        const response = await validateNIN(nin, IPFrontEnd);

        // console.log("RESPONSE", response);

        if (response?.code === "00") {
          if (response?.data?.firstName == null) {
            // console.log("JHDMFJFJFJK",response.data.data.firstName)

            setLoading(false);

            return swal.fire("Error", "NIN could not be validated", "error");
          }
          // await sendNIN(nin, bvn);
          const { firstName, lastName, dateOfBirth } = response?.data;

          if (
            bvnFirstName.trim() !== firstName.toLowerCase().trim() ||
            bvnLastName.trim() !== lastName.toLowerCase().trim() ||
            bvnDateOfBirth.trim() !== dateOfBirth.trim()
          ) {
            setLoading(false);
            return swal.fire(
              "Error",
              "BVN Details do not match that of the NIN",
              "error"
            );
          } else {
            const finalRes = await sendNIN(nin, bvn, IPFrontEnd);

            if (finalRes.code === "96") {
              setLoading(false);
              return swal.fire(
                "Error",
                "We already have a submission from you, Thank you",
                "error"
              );
            } else {
              toast.success("NIN Validation Successful");

              setShowNINForm(false);
              setShowSuccess(true);
            }
          }
        } else {
          setLoading(false);
          return swal.fire("Error", "Invalid NIN Entered", "error");
        }
      } catch (error) {
        setLoading(false);
        console.log("ERROR", error);
        return swal.fire(
          "Error",
          "Unable to validate NIN at this moment",
          "error"
        );
      }
    }
  };

  const handleDone = () => {
    window.location.href =
      "https://ubanking.suntrustng.com/internetBanking/#/login";
  };

  return (
    <div>
      <ToastContainer position="top-right" autoClose={3000} />
      <Nav />
      <div className="absolute inset-0 justify-center">
        <div className="bg-shape1 bg-teal opacity-50 bg-blur"></div>
        <div className="bg-shape2 bg-primary opacity-50 bg-blur"></div>
        <div className="bg-shape3 bg-yellow opacity-50 bg-blur"></div>
      </div>

      <section
        className="py-6 px-3 sm:py-16 lg:py-20  h-screen"
        style={{ zIndex: "1" }}
      >
        <div className="w-full float-right"></div>
        {showBvn && (
          <div
            className="w-full max-w-sm mt-20 p-8 mx-auto bg-white rounded-lg shadow-md"
            style={{ zIndex: "1" }}
          >
            <div className="flex mb-12 text-gray-800 text-sm justify-start mx-auto">
              <p>
                Kindly ensure that you have a Suntrust bank account. Provide
                your accurate BVN in the field below and proceed.
              </p>
            </div>

            <form className="">
              <div>
                <label className="block text-sm text-gray-700 dark:text-gray-200 mb-2">
                  Enter BVN:
                </label>
                <input
                  type="text"
                  placeholder={`${""} Enter your BVN`}
                  onChange={(e) => setBvn(e.target.value)}
                  required
                  className="block w-full px-4 py-2 mb-8 text-gray-700 bg-white border rounded-lg focus:border-blue-400 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                />
              </div>

              <div className="flex justify-center items-center">
                <button
                  onClick={(e) => handleSubmitBvn(e)}
                  className="w-2/3 px-6 py-1.5 text-md font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-green-800 rounded-sm hover:bg-green-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
                >
                  {loading ? <BeatLoader color="white" /> : <span>Submit</span>}
                </button>
              </div>
            </form>
          </div>
        )}

        {showOTPForm && (
          <div>
            <div className="w-full mt-20 max-w-sm p-6 m-auto mx-auto bg-white rounded-lg shadow-md ">
              <div className="flex justify-center mx-auto"></div>

              <form className="mt-6">
                <div>
                  {/* <label
                  className="block text-sm text-gray-800 dark:text-gray-200"
                >
                  BVN
                </label> */}
                  <input
                    type="text"
                    placeholder={`${"                  "}   Enter your OTP`}
                    onChange={(e) => setEnteredOtp(e.target.value)}
                    className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border rounded-lg focus:border-blue-400  focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                  />
                </div>

                <div className="mt-6">
                  <button
                    onClick={(e) => handleOtpValidation(e)}
                    className="w-full flex justify-center items-center px-6 py-2.5 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-green-800 rounded-lg hover:bg-green-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
                  >
                    {loading ? (
                      <BeatLoader color="white" />
                    ) : (
                      <span>SUBMIT</span>
                    )}
                  </button>
                </div>
              </form>

              <div className="flex items-center justify-between mt-4">
                <span className="w-1/5 border-b lg:w-1/5"></span>

                <span className="text-xs text-center text-gray-500 uppercase ">
                  Enter OTP sent to Email/SMS
                </span>

                <span className="w-1/5 border-b lg:w-1/5"></span>
              </div>
            </div>
          </div>
        )}

        {showNINForm && (
          <div>
            <div className="w-full mt-20 max-w-sm p-6 m-auto mx-auto bg-white rounded-lg shadow-md">
              {/* <div className="flex justify-center mx-auto">
                <img className="w-auto h-20 sm:h-20" src={sun} alt="" />
              </div> */}

              <form className="mt-6">
                <div>
                  {/* <label
            
                className="block text-sm text-gray-800 dark:text-gray-200"
              >
                BVN
              </label> */}
                  <input
                    onChange={(e) => setNin(e.target.value)}
                    type="text"
                    placeholder={`${"                "}  Enter your NIN`}
                    className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border rounded-lg focus:border-blue-400 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                  />
                </div>

                <div className="mt-6">
                  <button
                    onClick={(e) => handleNINSubmission(e)}
                    className="w-full px-6 py-2.5 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-green-800 rounded-lg hover:bg-green-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
                  >
                    {loading ? (
                      <BeatLoader color="white" />
                    ) : (
                      <span>SUBMIT</span>
                    )}
                  </button>
                </div>
              </form>

              <div className="flex items-center justify-between mt-4">
                <span className="w-1/5 border-b lg:w-1/5"></span>

                <span className="text-xs text-center text-gray-500 uppercase ">
                  enter your valid nin
                </span>

                <span className="w-1/5 border-b lg:w-1/5"></span>
              </div>
            </div>
          </div>
        )}

        {showSuccess && (
          <div className=" h-screen mt-2 px-5">
            <div className="bg-white sm:w-1/3 p-6 md:mx-auto">
              <Lottie
                animationData={success}
                loop={true}
                style={{ height: 200 }}
              />
              <div className="text-center my-4 mt-5">
                <h3 className="md:text-2xl text-base text-gray-900 font-semibold text-center">
                  Linking Complete!
                </h3>
                <p className="text-gray-600 my-2">
                  Thank you for banking with us 💛
                </p>
                <p> Have a great day! </p>
                <div>
                  <button
                    onClick={() => handleDone()}
                    className=" mt-4 px-12 bg-green-800 hover:bg-green-700 text-white font-semibold py-3"
                  >
                    <div className="text-center">Done</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="flex justify-end  mt-9 mr-10">
          <button
            className="btn flex justify-end bg-white  "
            onClick={() => document.getElementById("my_modal_5").showModal()}
          >
            Need Help <LuBadgeHelp />{" "}
          </button>
          <dialog
            id="my_modal_5"
            className="modal modal-bottom sm:modal-middle  "
          >
            <div className="modal-box  ">
              <h3 className="font-bold text-lg ">How to get your NIN</h3>
              <p className="py-4 data-theme ">
                Dial <b>*346# </b> to get your NIN
              </p>
              <div className="modal-action ">
                <form method="dialog">
                  {/* if there is a button in form, it will close the modal */}
                  <button className="btn  ">Close</button>
                </form>
              </div>
            </div>
          </dialog>
        </div>
      </section>
    </div>
  );
};

export default Home;
